import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 获取指定时区的当前时间
 * @param tz IANA 时区标识符（如 "America/New_York"）
 * @returns 指定时区的当前时间
 */
export function getNowInTimezone(tz: string): Dayjs {
  return dayjs().tz(tz);
}

/**
 * 获取指定时区的时间边界（最小和最大可选时间）
 * @param tz 目标时区
 * @param daysAhead 未来多少天可选（默认7天）
 * @returns 包含 minDate 和 maxDate 的对象
 */
export function getTimeBoundsInTimezone(tz: string, daysAhead: number = 7) {
  const nowInTz = getNowInTimezone(tz);
  return {
    minDate: nowInTz,
    maxDate: nowInTz.add(daysAhead, "day").endOf("day"),
  };
}
